/**
 * Order Repository
 * Aggregates split modules for backward compatibility
 */

import { orderQueries } from './orderQueries';
import { orderMutations } from './orderMutations';
import { orderSearch } from './orderSearch';

export type { DetailedOrder } from '../domain/types';

export { orderQueries, orderMutations, orderSearch };

export const orderRepository = {
  getMyOrders: orderQueries.getMyOrders.bind(orderQueries),
  getOrderById: orderQueries.getOrderById.bind(orderQueries),
  getAllOrders: orderQueries.getAllOrders.bind(orderQueries),
  getOrdersByPartner: orderQueries.getOrdersByPartner.bind(orderQueries),
  getOrdersByPartnerAndStatus: orderQueries.getOrdersByPartnerAndStatus.bind(orderQueries),
  saveGuestOrderId: orderMutations.saveGuestOrderId.bind(orderMutations),
  cancelOrder: orderMutations.cancelOrder.bind(orderMutations),
  toggleArchive: orderMutations.toggleArchive.bind(orderMutations),
  updateStatus: orderMutations.updateStatus.bind(orderMutations),
  createOrder: orderMutations.createOrder.bind(orderMutations),
  deleteAllOrders: orderMutations.deleteAllOrders.bind(orderMutations),
  updatePartnerOrderStatus: orderMutations.updatePartnerOrderStatus.bind(orderMutations),
  assignPartnerToOrder: orderMutations.assignPartnerToOrder.bind(orderMutations),
  linkGuestOrdersToUser: orderMutations.linkGuestOrdersToUser.bind(orderMutations),
  getPendingOrdersWithoutPartner: orderSearch.getPendingOrdersWithoutPartner.bind(orderSearch),
  searchOrdersByUserInfo: orderSearch.searchOrdersByUserInfo.bind(orderSearch),
  getOrdersByDateRange: orderSearch.getOrdersByDateRange.bind(orderSearch),
  getOrdersByStatus: orderSearch.getOrdersByStatus.bind(orderSearch),
};
